import { config } from '@air/api';

import { ANONYMOUS_COGNITO_CONFIG } from '../constants/cognitoConfig';

export const isAPIConfiguredForAnonymousSignUp = () => {
  const savedAPIConfig = config.getAuthConfiguration();

  return savedAPIConfig?.authenticationFlowType === ANONYMOUS_COGNITO_CONFIG.authenticationFlowType;
};
